import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import '../../CreateFeed/Inputs/Info.scss';
export default function Info() {
    const [isOpen, handleOpen] = useState(false);

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div 
                onClick={() => handleOpen(true)} 
                className="info-line" 
                style={{ cursor: 'pointer', margin: '0 10px' }}
                title="Advanced Search Operators"
            >
                <i className="fa fa-info-circle" />
            </div>

            <Modal style={{ height: '95vh' }} className="operators-modal" isOpen={isOpen} fade={false}>
                <ModalHeader toggle={() => handleOpen(!isOpen)}>
                    <strong>Search operators</strong>
                </ModalHeader>
                <ModalBody>
                    <Table className="search-operators-table" responsive>
                        <thead className="hidden">
                            <tr>
                                <th style={{ border: 'none' }}>Operator</th>
                                <th style={{ border: 'none' }}>Example</th>
                                <th style={{ border: 'none' }}>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">from a specific Twitter user</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div>@NASA<br/>or<br/><b>from:</b>NASA</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Sent from Twitter user "NASA"</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">mentions of</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile"><b>m:</b>@mashable</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Referencing Twitter account "mashable".</div>
                                </td>
                            </tr> */}

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">an exact word or phrase</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">"happy hour"</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing the exact phrase "happy hour".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">multiple words</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">happy hour</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing both "happy" and "hour" but not necessarily as an exact phrase.<br/>
                                    Note: Using "AND" is not needed. Simply list words you want to search for together.</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">OR</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">love&nbsp;<b>OR</b> hate</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing either "love" or "hate" (or both).</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">grouping</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">hotel (Boston OR "New York")</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing both "hotel" and either "Boston" or "New York".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">exclude</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">"annual report" -filing</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing "annual report" but not "filing".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">exclude groups</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div style={window.innerWidth < 1023 ? {textAlign: 'right'} : {}}>annual report -<b>(</b>filing OR stock<b>)</b></div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing both "annual" and "report" but not "filing" or "stock".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">exclude phrases</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile">social -"social media"</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing "social" anywhere in the message, but not "social media".</div>
                                </td>
                            </tr>

                            {/* <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">hashtag</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile"><b>#</b>haiku</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Containing the hashtag "haiku".</div>
                                </td>
                            </tr>

                            <tr className="table_row">
                                <td className="table_column">
                                    <strong className="table_lable">Operator</strong>
                                    <div className="text-for-mobile">cashtag</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Example</strong>
                                    <div className="text-for-mobile"><b>$</b>APPL</div>
                                </td>
                                <td className="table_column">
                                    <strong className="table_lable">Description</strong>
                                    <div className="text-for-mobile">Contains the $APPL cashtag.<br/>
                                    Note: Cashtags operate similar to a hashtag but are used for stock ticker symbols.</div>
                                </td>
                            </tr> */}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
        </div>
    );
}
